import React, { useState, useEffect } from "react";
import {
  Button,
  FormGroup,
  Form,
  Input,
  Col,
} from "reactstrap";
import { isAuthenticated, loginAdmin } from "../../api/Auth";
import { useNavigate } from "react-router-dom";

// Logo
import logo from "../../assets/img/icons/common/image__5_-removebg-preview 1.png";

const Login = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("admin@creadal.ai");
  const [password, setPassword] = useState("12345678");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  // Check authentication only on initial mount
  useEffect(() => {
    if (isAuthenticated()) {
      navigate("/admin/index");
    }
  }, [navigate]);

  const handleLogin = async () => {
    setLoading(true);
    setErrorMsg("");
    try {
      const res = await loginAdmin(email, password);
      if (res.payload.twoFactorRequired) {
        navigate("/auth/verify-2fa-otp", { state: { email } });
        return;
      }

      // Fetch user profile and save role
      try {
        const { getAdminProfile } = require("../../api/ApiServices");
        const profileRes = await getAdminProfile();
        let fetchedRole = "admin";
        if (profileRes && profileRes.payload && profileRes.payload.role) {
          fetchedRole = profileRes.payload.role.name || profileRes.payload.role;
        }
        localStorage.setItem("userRole", fetchedRole);
        if (profileRes?.payload?.permissions) {
          const keys = profileRes.payload.permissions.map((p) => p.p_name || p.p_key);
          localStorage.setItem("userPermissions", JSON.stringify(keys));
        }
        window.dispatchEvent(new Event("userRoleUpdated"));

        if (fetchedRole?.toLowerCase() === "judges") {
          navigate("/admin/judges-dashboard");
          return;
        }
      } catch (err) {
        console.error("Failed to fetch profile during login", err);
      }

      navigate("/admin/index");
    } catch (error) {
      console.error(error);
      setErrorMsg(error.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-card">
      {/* Logo */}
      <img src={logo} alt="CradleAI Logo" className="login-logo" />

      {/* Lock Icon */}
      <div className="lock-icon-wrapper">
        <i className="fas fa-lock-open"></i>
      </div>

      {/* Header */}
      <h1 className="admin-login-title">Admin Login</h1>
      <p className="admin-login-subtitle">
        Access the core management suite for the CradleAI ecosystem.
      </p>

      <Form role="form" onSubmit={(e) => e.preventDefault()}>
        {/* Email Field */}
        <div className="custom-form-group">
          <label className="custom-label">Email Address</label>
          <div className="custom-input-group">
            <i className="far fa-envelope"></i>
            <Input
              placeholder="admin@creadal.ai"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="new-email"
              required
            />
          </div>
        </div>

        {/* Password Field */}
        <div className="custom-form-group">
          <div className="custom-label-row">
            <label className="custom-label">Password</label>
            <a className="forgot-password-link" href="/auth/forgot-password">
              Forgot password?
            </a>
          </div>
          <div className="custom-input-group">
            <i className="fas fa-lock"></i>
            <Input
              placeholder="••••••••"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
              required
            />
            <i
              className={showPassword ? "fas fa-eye-slash" : "fas fa-eye"}
              onClick={() => setShowPassword(!showPassword)}
              style={{ cursor: "pointer", marginLeft: "10px", marginRight: 0 }}
            ></i>
          </div>
        </div>

        {/* Login Button */}
        <Button
          className="sign-in-btn"
          type="button"
          onClick={handleLogin}
          disabled={loading}
        >
          {loading ? "Signing in..." : "Sign In"}
          <i className="fas fa-arrow-right"></i>
        </Button>

        {/* Error Message */}
        {errorMsg && (
          <div className="text-danger text-center mt-3" style={{ fontWeight: 600 }}>{errorMsg}</div>
        )}
      </Form>
    </div>
  );
};

export default Login;
